// Returns a factory for ngModel.$options with value debounce.
export default function getOptionsDebounce() {
    return function(delay=1000, blur=0) {
        return {
            updateOn: 'blur',
            debounce: {default: delay, blur: blur},
            updateOnDefault: true
        };
    };
}



// WEBPACK FOOTER //
// ./forms/services/get-debounce-options.js